let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i13oj")).then(() => parcelRequire('aj6ox'));